import i18next from '../../i18n/config';

const initialState = {
    title: null,
    msg: {},
    status: null,
  };
  
  const messageReducer = (state = initialState, action) => {
    
    switch (action.type) {
      case "GET_MESSAGES":
        return {
          title: i18next.t(action.payload.title),
          msg: i18next.t(action.payload.msg),
          status: action.payload.status,
        };
      case "CLEAR_MESSAGES":
          return initialState;
      default:
        return state;
    }
  }
  
  export const returnMessages = (msg, status, title='') => {
    return {
      type: "GET_MESSAGES",
      payload: { msg, status, title },
    };
  };
  
  export const clearMessages = () => {
      return {
        type: "CLEAR_MESSAGES",
      };
  };

  // Messages aren't persisted, so one meant for after a full page reload is handed over
  // through sessionStorage: this tab only, shown once by App on load.
  const FLASH_MESSAGE_KEY = "ee-flash-message";

  export const setFlashMessage = (msg) => {
    try {
      sessionStorage.setItem(FLASH_MESSAGE_KEY, msg);
    } catch (e) {
      // storage unavailable: the message is simply not shown
    }
  };

  export const takeFlashMessage = () => {
    try {
      const msg = sessionStorage.getItem(FLASH_MESSAGE_KEY);
      sessionStorage.removeItem(FLASH_MESSAGE_KEY);
      return msg;
    } catch (e) {
      return null;
    }
  };

  
  export default messageReducer;